import React from 'react'
import { RequirementMetIndicator } from 'components'

function usePasswordComplexityCheck(password = '') {
  let oneDigit = /\d/.test(password)
  let length = /(.{8})/.test(password)
  let upperAndLowerCase = /[A-Z]/.test(password) && /[a-z]/.test(password)
  let specialChar = /[!@#*+_?\-]/.test(password)

  const isPasswordValid = React.useCallback(
    () =>
      oneDigit && length && upperAndLowerCase && specialChar
        ? true
        : 'La contraseña no cumple las condiciones mínimas',
    [oneDigit, length, upperAndLowerCase, specialChar]
  )

  const PasswordRequirements = React.useCallback(() => {
    return (
      <div className="flex flex-col gap-2">
        <RequirementMetIndicator
          condition="Mínimo 8 caracteres"
          conditionStatus={length}
        />
        <RequirementMetIndicator
          condition="Al menos, una mayúscula y una minúscula"
          conditionStatus={upperAndLowerCase}
        />
        <RequirementMetIndicator
          condition="Al menos, un caracter especial (ej. @ - # ! ? _ + *)"
          conditionStatus={specialChar}
        />
        <RequirementMetIndicator
          condition="Al menos, un numero (0-9)"
          conditionStatus={oneDigit}
        />
      </div>
    )
  }, [oneDigit, length, upperAndLowerCase, specialChar])

  return [isPasswordValid, { PasswordRequirements }]
}

export default usePasswordComplexityCheck
